export const state = {
  profiles: [],
  isLoading: false,
  totalRecords: 0,
  profilePerPage: 10000,
  activePage: 1
}
